import React from 'react';
import { Slot } from '@radix-ui/react-slot';

export function Button({ className, variant = 'default', size = 'default', asChild = false, children, ...props }) {
  const baseStyles = "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 disabled:pointer-events-none disabled:opacity-50";

  const variants = {
    default: "bg-primary text-white hover:bg-primary/90",
    outline: "border bg-transparent",
    ghost: "bg-transparent",
    icon: "h-10 w-10 p-0",
  };

  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 px-3",
    lg: "h-11 px-8",
    icon: "h-10 w-10",
  };

  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className || ''}`;
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp className={classes} {...props}>
      {children}
    </Comp>
  );
}
